import AuthService from "@/services/feature/auth.service";

export const authApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    sendRecoveryLink({ commit }, userName) {
      return AuthService.sendRecoveryLink(userName).then(
        (resp) => {
          commit("dummy", "AuthService.sendRecoveryLink - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "AuthService.sendRecoveryLink - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
